/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import { SubscriptionService } from '../../models/SubscriptionService';
import { SocketConnection } from '../../sockets/socket.connections';
import { SFGOAuthService } from "../../../../providers/sfgoauth.service/sfgoauth.service";


/**
 * Api services for the `SubscriptionService` model.
 */
@Injectable()
export class SubscriptionServiceApi extends BaseLoopBackApi {
  SFGoAuth: any;

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler,
    public sfgoAuthService: SFGOAuthService
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `params` – `{Object}` -
   *
   *  - `redir` – `{string}` -
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `SubscriptionService` object.)
   * </em>
   */
  public getRequest(params: any, redir: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SubscriptionServices/getRequest/";
    let _routeParams: any = {};
    let _postBody: any;

    if (params) {
      _postBody = {
        ...params,
        params
      }
    } else {
      _postBody = {
        params
      };
    }

    let _urlParams: any = {};
    if (typeof redir !== 'undefined' && redir !== null) _url = _url + redir;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  public async checkActiveTransaction() {
    return new Promise<any>(async (resolve, reject) => {
      try {
        this.SFGoAuth = await this.sfgoAuthService.getAuthorization();

        let _method: string = "POST";
        let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
          "/subcription/checkActiveTransaction/";
        let _routeParams: any = {};
        let _postBody: any;

        _postBody = {
          companyCode: this.SFGoAuth.companyCode
        };

        let _urlParams: any = {};
        let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null);
        resolve(result);
      } catch (e) {
        console.log(e);
        reject(e);
      }
    })
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SubscriptionService`.
   */
  public getModelName() {
    return "SubscriptionService";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SubscriptionService.ts